import { BASE_URL_API } from "../../../constants";
import fetcher, { _api_download_file } from "../../../utils/fetcher";

/**
 * Synthèse annuelle des onglets Mon équipe (manager) et Entreprise (hr).
 * Les deux onglets partagent le même contrat, seul le préfixe change.
 * @typedef {"manager"|"hr"} SummaryScope
 */

export const QUERY_KEY_SUMMARY = "time_reporting_summary";
export const QUERY_KEY_SUMMARY_FILTERS = "time_reporting_summary_filters";

/**
 * Query string commune : ud=u-<id> / ud=d-<id> et status=<month_status> (répétables)
 * @param {{ ud?: string[], status?: string[], start_date?: string, end_date?: string }} params
 */
export const buildSummarySearchParams = ({
    ud = [],
    status = [],
    start_date,
    end_date,
} = {}) => {
    const params = new URLSearchParams();
    if (start_date) params.set("start_date", start_date);
    if (end_date) params.set("end_date", end_date);
    ud.forEach((value) => {
        params.append("ud", value);
    });
    status.forEach((value) => {
        params.append("status", value);
    });
    return params.toString();
};

// fetcher ne lève pas d'erreur sur 4xx : on la lève pour react-query
const throwIfError = (data) => {
    if (data?.error || (data?.res && !data.res.ok)) {
        throw new Error(data?.message || "Une erreur s'est produite");
    }
    return data;
};

/** GET /time_reporting/<scope>/year/<year>/summary?ud=…&status=… */
export const _api_get_summary = ({ scope, year, ud, status }) => {
    const query = buildSummarySearchParams({ ud, status });
    return fetcher(
        `${BASE_URL_API}/time_reporting/${scope}/year/${year}/summary?${query}`,
        { method: "GET", credentials: "include" }
    ).then(throwIfError);
};

/** GET /time_reporting/<scope>/year/<year>/summary/filters?ud=… : compteurs État, départements, collaborateurs */
export const _api_get_summary_filters = ({ scope, year, ud }) => {
    const query = buildSummarySearchParams({ ud });
    return fetcher(
        `${BASE_URL_API}/time_reporting/${scope}/year/${year}/summary/filters?${query}`,
        { method: "GET", credentials: "include" }
    ).then(throwIfError);
};

/** GET /time_reporting/<scope>/summary/export?start_date=…&end_date=…&ud=…&status=… (xlsx) */
export const _api_export_summary = ({
    scope,
    start_date,
    end_date,
    ud,
    status,
    cbOnEndDownload,
}) =>
    _api_download_file({
        url: `${BASE_URL_API}/time_reporting/${scope}/summary/export?${buildSummarySearchParams(
            { ud, status, start_date, end_date }
        )}`,
        defaultFilename: `Activite_${start_date}-${end_date}.xlsx`,
        cbOnEndDownload,
    });
